import React from 'react'
import {Link} from "react-router-dom";

export default function Footer() {
  return (
    <>
      <footer>
    <div className="container">
        <div className="row">
            <div className="col-md-4">
                <div className="footAbout">
                    <h4>About Us</h4>
                    <p>Unlock Destinations is a dynamic travel company dedicated to providing exceptional travel experiences to its customers. With a passion for exploration and a commitment to customer satisfaction, we strive to create memorable journeys that exceed expectations. Our mission is to inspire and enable people to explore the world by offering a diverse range of travel services that cater to various interests, preferences, and budgets.</p>
                    <div className="social">
                                      <ul>
                                        <li><Link target='_blank' to="https://www.facebook.com/unlock.destinations/"><img src="/assets/img/facebook.png" alt="Facebook" /><span>Facebook</span></Link></li>
                                        <li><Link target='_blank' to="https://www.instagram.com/unlock_destinations/"><img src="/assets/img/instagram.png" alt="Instagram" /><span>Instagram</span></Link></li>
                                        <li><Link target='_blank' to="https://www.google.com/search?q=unlock+destinations+reviews&sca_esv=f0158aba78c19323&sxsrf=AE3TifPw0RXASIiECFGdEeXNS5MwXU-Mlg%3A1765546875802&ei=exs8afHLMNuUseMP9IfliAw&oq=unlock+destinations+&gs_lp=Egxnd3Mtd2l6LXNlcnAiFHVubG9jayBkZXN0aW5hdGlvbnMgKgIIATIGEAAYFhgeMgYQABgWGB4yBhAAGBYYHjICECYyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYgAQYogQyCBAAGIAEGKIESLYSUKwEWKwEcAB4ApABAJgBxAGgAcQBqgEDMC4xuAEByAEA-AEBmAICoALWAcICBBAAGEeYAwDiAwUSATEgQIgGAZAGApIHBTEuMC4xoAe8BbIHAzItMbgHzgHCBwMyLTLIBwuACAA&sclient=gws-wiz-serp#lrd=0x390ce33bbb6ba2ff:0x3f0a39a03443fc23,1,,,,"><img className="google" src="/assets/img/google-sm.png" alt="Google" /></Link></li>
                                      </ul>
                    </div>
                </div>
            </div>

            <div className="col-6 col-md-4">
                <div className="quickLinks">
                    <h4>International</h4>
                    <ul>
                        <li><Link to="/TravelPackagesCraft/Dubai">Dubai</Link></li>
                        <li><Link to="/TravelPackagesCraft/Bali">Bali</Link></li>
                        <li><Link to="/TravelPackagesCraft/Maldives">Maldives</Link></li>
                        <li><Link to="/TravelPackagesCraft/Thailand">Thailand</Link></li>
                    </ul>
                </div>
                <div className="quickLinks">
                    <h4>Domestic</h4>
                    <ul>
                        <li><Link to="/TravelPackagesCraftIndia/ladakh">Leh</Link></li>
                        <li><Link to="/TravelPackagesCraftIndia/Kerala">Kerala</Link></li>
                        <li><Link to="/TravelPackagesCraftIndia/Rajasthan">Rajasthan</Link></li>
                        <li><Link to="/TravelPackagesCraftIndia/Andaman">Andaman</Link></li>
                    </ul>
                </div>
            </div>

            <div className="col-6 col-md-4">
                <div className="quickLinks">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/AboutUs">About Us</Link></li>
                        <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                        <li><Link to="/TermsCondition">Terms & Conditions</Link></li>
                        <li><Link to="/ContactUs">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>

<div className='whatsapp'><Link target='_blank' className="nav-link" to="https://api.whatsapp.com/send/?phone=%2B918766234500&text=Hi,+I+was+browsing+your+website+and+wanted+more+details+about+your+travel+packages.&type=phone_number&app_absent=0"> <img className="shake-horizontal" src="/assets/img/whatsapp.webp" alt="" /></Link></div>
    </>
  )
}
